export default __webpack_public_path__ + "0c5285d70f160aa8871d31e1205ab26e.jpg";